<template>
  <div v-if="message">
    <div :style="getStyleCSS(bubbleOwner)">
      <b-row>
        <b-col>
          {{message}}
        </b-col>
      </b-row>
      <template v-if="isIona(bubbleOwner)">
        <hr />
        <b-row>
          <b-col
              cols="8"
          >
            <b-icon
                v-b-popover.top.hover="popupText"
                @mouseleave="changePopupText"
                @click="handleCopyToClipboard()"
                style="margin-right: 10px;cursor:pointer"
                icon="files"
                aria-hidden="true"
            />
          </b-col>
          <b-col>
            <div>
              <b-icon
                  @click="handleThumbClick(true)"
                  style="margin-right: 10px;cursor:pointer"
                  icon="hand-thumbs-up"
                  aria-hidden="true"
              />
              <b-icon
                  @click="handleThumbClick(true)"
                  style="cursor:pointer"
                  icon="hand-thumbs-down"
                  aria-hidden="true"/>
            </div>
          </b-col>
        </b-row>
      </template>
    </div>
  </div>
</template>
<script>
export default {
  name: "IONA_ChatSideBar_Bubble",
  components: {},
  props: {
    bubbleOwner: {
      type: String,               //iona | preset | user | other
      required: true
    },
    profile: {
      type: Object,
      required: true,
      default: () => {
        return {};
      }
    },
    message: {
      type: String,
      required: true
    },
  },
  created() {},
  mounted() {},
  computed: {},
  methods: {
    isIona(bubbleOwner){
      return bubbleOwner === "iona";
    },
    getStyleCSS(bubbleOwner){
      switch (bubbleOwner){
        case 'iona':
          return "background-color: #EFEDEAFF;color: #000000;border-radius: 15px;padding: 10px;margin-top:10px;margin-right:50px";
          break;
        case 'user':
          return "background-color: #286fea;color: #FFFFFF;border-radius: 15px;padding: 10px;margin-top:10px;margin-left:50px";
          break;
        case 'fam':
          return "background-color: #cbcb71;color: #000000;border-radius: 15px;padding: 10px;margin-top:10px;margin-right:50px";
          break;
        case 'preset':
          return "background-color: #FFFFFF;color: #000000;border-radius: 15px;padding: 10px;margin-top:10px;";
          break;
        default:
          return "background-color: #b2a997;color: #FFFFFF;border-radius: 15px;padding: 10px;margin-top:10px;margin-right:50px";
          break;
      }
    },
    handleThumbClick(isThumbUp){
      this.$emit('is-thumb-up', this.message, isThumbUp);
    },
    handleCopyToClipboard(){
      navigator.clipboard.writeText(this.message);
      this.popupText = "Copied!";
    },
    changePopupText() {
      setTimeout(() => {
        this.popupText = "Copy to clipboard";
      }, 300);
    }
  },
  data() {
    return {
      popupText: "Copy to clipboard"
    };
  }
};
</script>

<style lang="scss" scoped>
.fam {
  background-color: #cbcb71;
}
</style>
